import { all } from 'redux-saga/effects';
import summary from 'sagas/dashboard/company/summary';

export default function* company() {
  yield all([summary()]);
}
